import { MeetingResponse, createTeamsPayload, updateTeamsPayload } from '../features/AppReview/AppReviewTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_app_review = '/{0}/{1}/appReview.list';
const create_app_review = '/{0}/appReview.add';
const delete_app_review = '/{0}/{1}/appReview.delete';
const update_app_review = '/{0}/{1}/appReview.update';
const fetch_app_review_details = '/{0}/{1}/appReview.detail';
const question_app_update = '/application.updateAppResponse';
const evaluation_question_app_update = '/job-evaluation/updateResponse';

// app jounry
const fetch_app_journey = '/{0}/{1}/journey.list';
const create_evaluation = '/job-evaluation/assign';


const credentialsConfig = {
    withCredentials: true,
}


export const fetchReviewData = async (baseId: number, appId: number): Promise<MeetingResponse> => {
    const fetch_meeting_data = formatUrl(fetch_app_review, [baseId, appId]);
    return get<MeetingResponse>(fetch_meeting_data, credentialsConfig);
};


export const createAppReviewData = async (data: createTeamsPayload, userId: number): Promise<MeetingResponse> => {
    const base_create_meeting = formatUrl(create_app_review, [userId]);
    return post<MeetingResponse>(base_create_meeting, data, credentialsConfig);
};
export const createEvaluationData = async (data: createTeamsPayload, userId: number): Promise<MeetingResponse> => {
    const evaluation_create_meeting = formatUrl(create_evaluation, [userId]);
    return post<MeetingResponse>(evaluation_create_meeting, data, credentialsConfig);
};


export const deleteAppReview = async (baseId: number, id: number): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(delete_app_review, [baseId, id]);
    return del<MeetingResponse>(formattedUrl, credentialsConfig);
};
export const updateInternalQuestionValue = async (data: any): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(question_app_update, []);
    return post<MeetingResponse>(formattedUrl, data, credentialsConfig);
};

export const updateEvaluationQuestionAnswer = async (data: any): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(evaluation_question_app_update, []);
    return post<MeetingResponse>(formattedUrl, data, credentialsConfig);
};

export const updateAppReview = async (baseId: number, id: number, data: updateTeamsPayload): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(update_app_review, [baseId, id]);
    return put<MeetingResponse>(formattedUrl, data, credentialsConfig);
};

export const fetchAppReviewDetails = async (baseId: number, id: number): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(fetch_app_review_details, [baseId, id]);
    return get<MeetingResponse>(formattedUrl, credentialsConfig);
};

export const fetchAppJourney = async (baseId: number, appId: number): Promise<MeetingResponse> => {
    const formattedUrl = formatUrl(fetch_app_journey, [baseId, appId]);
    return get<MeetingResponse>(formattedUrl, credentialsConfig);
};


